(function() {
    'use strict';

    angular.module('doclr.components.vrijgavestrategieselector', ['doclr.components.util'])
        .directive('doclrVrijgaveStrategieSelector', function (borderColor) {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    vrijgaveStrategie: '=',
                    vrijgaveVolgnummer: '=',
                    vrijgaveGroep: '=',
                    onChange: '&?'
                },
                template: '<div class="vrijgaveselector btn-group btn-group-vertical" role="group">' +
                                '<div ng-click="selectMeteen()" type="button" class="btn-group btn btn-default btn-sm" ng-class="{active : !vrijgaveStrategie}">Meteen</div>' +
                                '<div ng-click="selectDagZelf()" type="button" class="btn-group btn btn-default btn-sm" ng-class="{active : vrijgaveStrategie === \'dagZelf\'}">' +
                                    '<span class="badge badge-rectangle pull-right">D</span>' +
                                    'Dag zelf' +
                                '</div>' +
                                '<div class="btn-group vrijgave-in-volgorde btn btn-default btn-sm" ng-class="{active : vrijgaveStrategie === \'inVolgorde\'}">' +
                                    'In volgorde' +
                                    '<table style="width: 100%">' +
                                        '<tr><td style="text-align: center" colspan="4" ng-click="updateVolgnummers(-volgnummers.length)" ng-style="{visibility : (isMinimum() ? \'hidden\' : \'visible\')}"><i class="fa fa-chevron-up"></i></td></tr>' +
                                        '<tr ng-repeat="volgnummer in volgnummers">' +
                                            '<td ng-repeat="groep in groepen" style="text-align: center">' +
                                                '<span ng-click="selectInVolgorde(groep, volgnummer)" ' +
                                                        'class="badge badge-rectangle badge-rectangle-md" ' +
                                                        'ng-style="{ \'background-color\': groep, \'border-color\': (vrijgaveVolgnummer === volgnummer && vrijgaveGroep === groep ? borderColor(groep) : \'transparent\') }"> ' +
                                                        '{{volgnummer}}' +
                                                '</span>' +
                                            '<td>' +
                                        '</tr>' +
                                        '<tr><td style="text-align: center" colspan="4" ng-click="updateVolgnummers(volgnummers.length)" ng-style="{visibility : (isMaximum() ? \'hidden\' : \'visible\')}"><i class="fa fa-chevron-down"></i></td></tr>' +
                                    '</table>' +
                                '</div>' +
                                '</div>' +
                            '</div>',
                link: function(scope) {
                        const MIN = 1, MAX = 60;

                        scope.groepen = ['#7EA0B9', '#BFAE50', '#61A953', '#A64C4C'];
                        scope.volgnummers = [1, 2, 3, 4];
                        scope.updateVolgnummers = function(offset) {
                            scope.volgnummers = scope.volgnummers.map(volgnummer => {
                                var nextVolgnummer = volgnummer + offset;
                                return (nextVolgnummer < MIN || nextVolgnummer > MAX) ? volgnummer : nextVolgnummer;
                            });
                        };

                        function onChange(vrijgaveStrategie, vrijgaveGroep, vrijgaveVolgnummer) {
                            scope.vrijgaveStrategie = vrijgaveStrategie;
                            scope.vrijgaveGroep = vrijgaveGroep;
                            scope.vrijgaveVolgnummer = vrijgaveVolgnummer;
                            if (angular.isDefined(scope.onChange)) {
                                scope.onChange({ vrijgaveStrategie, vrijgaveGroep, vrijgaveVolgnummer });
                            }
                        }

                    scope.selectInVolgorde = function(groep, volgnummer) {
                        onChange('inVolgorde', groep, volgnummer);
                    };

                    scope.selectMeteen = function() {
                        onChange(null, null, null);
                    };

                    scope.selectDagZelf = function() {
                        onChange('dagZelf', null, null);
                    };

                    scope.isMaximum = function() {
                        return _.max(scope.volgnummers) >= MAX;
                    };

                    scope.isMinimum = function() {
                        return _.min(scope.volgnummers) <= MIN;
                    };

                    scope.borderColor = function(color) {
                        return borderColor(color);
                    };
                }
            };
        });
})();
